import instance from "../../network/index"; // Import your axios instance

const storePaymentStatus = async (data) => {
  try {
    const response = await instance.post("/api/v1/subscription", data);
    const responseData = response.data;
    return responseData;
  } catch (err) {
    return {
      status: "failed",
      message: err?.response?.data?.error || "An error occurred while storing payment status"}
  }
};

const storeSubscriptionItems = async (data) => {
  try {
    const response = await instance.post("/api/v1/subscription/items", data);
    const responseData = response.data;
    return responseData;
  } catch (err) {
    throw new Error(err);
  }
};

const updateSubscriptionItems = async (data) => {
  try {
    const response = await instance.patch("/api/v1/subscription/items", data);
    const responseData = response.data;
    return responseData;
  } catch (err) {
    throw new Error(err);
  }
};


const fetchSubscriptionApi = async() => {
  try {
    const response = await instance.get("/api/v1/subscription?include=items");
    const responseData = response.data?.data;
    if(!responseData || responseData?.status == 404) {
      return {
        "status" : 404
      };
    }
    return responseData;
  } catch (err) {
    console.log(err);
    return null;
  }
} 

export { storePaymentStatus, storeSubscriptionItems, updateSubscriptionItems, fetchSubscriptionApi };
